/* ============================================================
   Aqua Tank Works — behaviour
   No dependencies. Everything degrades to working HTML.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Header: solidify once you leave the hero ---------- */
  function header() {
    var hdr = $('[data-header]');
    if (!hdr) return;
    var solid = false;
    function tick() {
      var want = window.scrollY > 24;
      if (want !== solid) { solid = want; hdr.classList.toggle('hdr--solid', want); }
    }
    addEventListener('scroll', tick, { passive: true });
    tick();
  }

  /* ---------- Header "Shop" dropdown ---------- */
  function navDropdowns() {
    var drops = $$('[data-hdr-drop]');
    if (!drops.length) return;

    function closeAll(except) {
      drops.forEach(function (d) {
        if (d === except) return;
        d.setAttribute('data-open', 'false');
        $('.hdr__drop-btn', d).setAttribute('aria-expanded', 'false');
      });
    }

    drops.forEach(function (d) {
      var btn = $('.hdr__drop-btn', d);
      var closeTimer = null;

      function open() {
        clearTimeout(closeTimer);
        closeAll(d);
        d.setAttribute('data-open', 'true');
        btn.setAttribute('aria-expanded', 'true');
      }
      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          d.setAttribute('data-open', 'false');
          btn.setAttribute('aria-expanded', 'false');
        }, 160);
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = d.getAttribute('data-open') === 'true';
        if (isOpen) { d.setAttribute('data-open', 'false'); btn.setAttribute('aria-expanded', 'false'); }
        else open();
      });
      d.addEventListener('mouseenter', open);
      d.addEventListener('mouseleave', scheduleClose);
      d.addEventListener('focusin', open);
      d.addEventListener('focusout', function (e) {
        if (!d.contains(e.relatedTarget)) scheduleClose();
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-hdr-drop]')) closeAll();
    });
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ---------- Mobile drawer ---------- */
  function drawer() {
    var el = $('[data-drawer]');
    var open = $('[data-drawer-open]');
    var close = $('[data-drawer-close]');
    if (!el || !open) return;
    var lastFocus = null;

    function setOpen(state) {
      el.setAttribute('data-open', state ? 'true' : 'false');
      el.setAttribute('aria-hidden', state ? 'false' : 'true');
      open.setAttribute('aria-expanded', state ? 'true' : 'false');
      document.documentElement.style.overflow = state ? 'hidden' : '';
      if (state) {
        lastFocus = document.activeElement;
        var first = el.querySelector('a, button');
        if (first) first.focus();
      } else if (lastFocus) {
        lastFocus.focus();
      }
    }
    open.addEventListener('click', function () { setOpen(true); });
    if (close) close.addEventListener('click', function () { setOpen(false); });
    $$('a', el).forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.getAttribute('data-open') === 'true') setOpen(false);
    });
    // Keep focus inside while open
    el.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || el.getAttribute('data-open') !== 'true') return;
      var f = $$('a[href], button:not([disabled]), input, textarea, select', el)
        .filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ============================================================
     HERO — the cross-section selector.
     Picking a geometry redraws its plan view and swaps the tank.
     ============================================================ */
  function hero() {
    var root = $('[data-hero]');
    if (!root) return;

    var shapes  = $$('[data-shape]', root);
    var shots   = $$('[data-shot]', root);
    var fig     = $('[data-section-fig]', root);
    var nameEl  = $('[data-readout-name]', root);
    var dimsEl  = $('[data-readout-dims]', root);
    var priceEl = $('[data-readout-price]', root);
    var linkEl  = $('[data-readout-link]', root);
    if (!shapes.length) return;

    var idx = -1;
    var timer = null;

    function draw(pathData) {
      if (!fig) return;
      fig.setAttribute('data-draw', 'false');
      var svg = fig.querySelector('svg');
      if (!svg) return;
      svg.innerHTML = '';
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', pathData);
      svg.appendChild(p);
      // Plot the outline like a drawing being traced
      var len = 400;
      try { len = Math.ceil(p.getTotalLength()) || 400; } catch (e) {}
      fig.style.setProperty('--len', len);
      // force reflow so the animation restarts
      void fig.offsetWidth;
      fig.setAttribute('data-draw', 'true');
    }

    function select(i, userInitiated) {
      if (i === idx) return;
      idx = i;
      var btn = shapes[i];

      shapes.forEach(function (s, n) { s.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      shots.forEach(function (s, n) { s.setAttribute('data-active', n === i ? 'true' : 'false'); });

      if (nameEl)  nameEl.textContent  = btn.getAttribute('data-name') || '';
      if (dimsEl)  dimsEl.textContent  = btn.getAttribute('data-dims') || '';
      if (priceEl) priceEl.textContent = btn.getAttribute('data-price') || '';
      if (linkEl) {
        var href = btn.getAttribute('data-url');
        if (href) linkEl.setAttribute('href', href);
      }
      draw(btn.getAttribute('data-section') || '');

      if (userInitiated) stop();
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    shapes.forEach(function (s, i) {
      s.addEventListener('click', function () { select(i, true); });
      s.addEventListener('mouseenter', function () { select(i, true); });
      s.addEventListener('focus', function () { select(i, true); });
      // Roving arrow-key navigation across the rail
      s.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % shapes.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + shapes.length) % shapes.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = shapes.length - 1;
        if (next !== null) { e.preventDefault(); shapes[next].focus(); }
      });
    });

    select(0, false);

    // Gentle auto-advance so the idea reveals itself — stops on any interaction
    if (!reduced && shapes.length > 1) {
      var started = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && !started) {
            started = true;
            timer = setInterval(function () { select((idx + 1) % shapes.length, false); }, 4200);
          } else if (!en.isIntersecting) {
            stop();
          }
        });
      }, { threshold: .35 });
      io.observe(root);
      ['pointerdown', 'keydown', 'wheel'].forEach(function (ev) {
        root.addEventListener(ev, stop, { once: true, passive: true });
      });
    }
  }

  /* ---------- Scroll reveal ---------- */
  function reveal() {
    var items = $$('.reveal');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (n) { n.setAttribute('data-shown', 'true'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var group = $$('.reveal', en.target.parentNode);
        var i = group.indexOf(en.target);
        en.target.style.setProperty('--d', Math.min(i, 6) * 70 + 'ms');
        en.target.setAttribute('data-shown', 'true');
        io.unobserve(en.target);
      });
    }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (n) { io.observe(n); });
  }

  /* ---------- Accordions ---------- */
  function accordions() {
    $$('[data-acc-btn]').forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var inner = panel.firstElementChild;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (reduced) { panel.style.height = open ? '0px' : 'auto'; return; }
        if (open) {
          panel.style.height = inner.offsetHeight + 'px';
          void panel.offsetWidth;
          panel.style.height = '0px';
        } else {
          panel.style.height = inner.offsetHeight + 'px';
          panel.addEventListener('transitionend', function te() {
            panel.style.height = 'auto';
            panel.removeEventListener('transitionend', te);
          });
        }
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function qty() {
    $$('[data-qty]').forEach(function (box) {
      var input = $('input', box);
      if (!input) return;
      $$('button', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var v = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, v);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Product variant picker ---------- */
  function variants() {
    var form = $('[data-variant-form]');
    if (!form) return;
    var data = $('[data-variant-json]');
    if (!data) return;

    var variantList;
    try { variantList = JSON.parse(data.textContent); } catch (e) { return; }

    var idInput  = $('[data-variant-id]', form);
    var priceEl  = $('[data-variant-price]');
    var addBtn   = $('[data-add-btn]', form);
    var groups   = $$('[data-option-group]', form);

    function chosen() {
      return groups.map(function (g) {
        var on = $('[aria-pressed="true"]', g);
        return on ? on.getAttribute('data-value') : null;
      });
    }

    function money(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
    }

    function sync() {
      var picked = chosen();
      var match = variantList.find(function (v) {
        return picked.every(function (p, i) { return p === null || v.options[i] === p; });
      });

      // Grey out combinations that don't exist
      groups.forEach(function (g, gi) {
        $$('[data-value]', g).forEach(function (opt) {
          var test = picked.slice();
          test[gi] = opt.getAttribute('data-value');
          var exists = variantList.some(function (v) {
            return test.every(function (p, i) { return p === null || v.options[i] === p; });
          });
          opt.setAttribute('data-unavailable', exists ? 'false' : 'true');
        });
      });

      if (!match) {
        if (addBtn) { addBtn.setAttribute('aria-disabled', 'true'); addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (addBtn) {
        if (match.available) {
          addBtn.removeAttribute('aria-disabled');
          addBtn.textContent = 'Add to cart';
        } else {
          addBtn.setAttribute('aria-disabled', 'true');
          addBtn.textContent = 'Sold out';
        }
      }
      // Reflect the choice in the URL so the variant is shareable
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        history.replaceState({}, '', u);
      }
    }

    groups.forEach(function (g) {
      $$('[data-value]', g).forEach(function (opt) {
        opt.addEventListener('click', function () {
          $$('[data-value]', g).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          opt.setAttribute('aria-pressed', 'true');
          var label = $('[data-option-current]', g);
          if (label) label.textContent = opt.getAttribute('data-value');
          sync();
        });
      });
    });
    sync();
  }

  /* ---------- Product gallery ---------- */
  function gallery() {
    var main = $('[data-gallery-main]');
    if (!main) return;
    $$('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        $$('[data-gallery-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        main.src = t.getAttribute('data-full');
        main.alt = t.getAttribute('data-alt') || '';
      });
    });
  }

  /* ---------- Boot ---------- */
  function init() {
    header(); navDropdowns(); drawer(); hero(); reveal();
    accordions(); qty(); variants(); gallery();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
